import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

export const useGetQueryParams = (): string => {
  const { search } = useLocation()

  return useMemo(() => {
    if (search) {
      const queryString = new URLSearchParams(search)
      const newQueryString = new URLSearchParams()

      if (queryString.has('sort')) {
        newQueryString.append('sort', queryString.get('sort') as string)
      }

      if (queryString.has('view')) {
        newQueryString.append('view', queryString.get('view') as string)
      }
      if (newQueryString.has('view') || newQueryString.has('sort')) {
        return `?${newQueryString.toString()}`
      }
    }

    return ''
  }, [search])
}
